<template>
  <div />
</template>

<script setup lang="ts">
import { ref, computed, watch, onMounted, onBeforeUnmount } from 'vue';
import axios from 'axios';
import { useFormsStore } from '@/store/useFormsStore';
import { useSentry } from '@/composables';

import pkg from '@freelancerepublik/version/package.json';

const sentry = useSentry();
const formsStore = useFormsStore();

const intervalId = ref<number | undefined>(undefined);
const remoteVersion = ref<string | undefined>(undefined);

const isAnyEditedForm = computed(() => formsStore.isAnyEditedForm);

const shouldUpgrade = computed(
  () => remoteVersion.value !== undefined && pkg.version !== remoteVersion.value && !isAnyEditedForm.value
);

watch(shouldUpgrade, (val) => {
  if (val) window.location.reload();
});

async function getRemoteVersion() {
  try {
    const versionURI = `${window.location.protocol}//${window.location.host}/version?ts=${new Date().valueOf()}`;
    const response = await axios.get(versionURI);
    remoteVersion.value = response.data;
  } catch (err) {
    sentry.captureException(err);
  }
}

function startAppUpgrader() {
  intervalId.value = window.setInterval(() => getRemoteVersion(), 60 * 1000);
}

function stopAppUpgrader() {
  if (intervalId.value) {
    window.clearInterval(intervalId.value);
  }
}

onMounted(async () => {
  const { ENV } = await import('@/env');
  if (['production', 'staging'].includes(ENV.CONFIG_ENV)) {
    startAppUpgrader();
  }
});

onBeforeUnmount(() => {
  stopAppUpgrader();
});
</script>
